module.exports = "https://www.gc-qa.gnp.com.mx/d523e3ec9b59314f1e56d47869c2b8d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-1.png
// module id = 8146
// module chunks = 0